import {
  Box,
  Flex,
  HStack,
  LegacyText,
  Link,
  SystemProps,
  Text,
  VStack,
} from "flicket-ui";
import { Icon } from "~components";
import { ReactNode } from "react";
import { pick } from "@styled-system/props";

interface BaseSubHeaderProps {
  title: ReactNode;
  backToLinkText: string;
  subTitle?: ReactNode;
  isSinglePage: boolean;
  backToLink: string;
  hideBackLink?: boolean;
  colour?: SystemProps["color"];
}

interface SubHeaderProps extends Omit<SystemProps, "title"> {
  title: ReactNode;
  backToLinkText: string;
  subTitle?: ReactNode;
  isSinglePage: boolean;
  backToLink: string;
  hideBackLink?: boolean;
  textColor?: SystemProps["color"];
}

export const SubHeader = ({
  backToLink,
  backToLinkText,
  isSinglePage,
  title,
  hideBackLink,
  textColor,
  subTitle,
  ...props
}: SubHeaderProps) => (
  <VStack {...pick(props)}>
    {hideBackLink ? null : (
      <Link to={backToLink}>
        <HStack alignItems="center" opacity="inherit">
          <Icon icon="chevron-left" fontSize={5} color={textColor} />
          {isSinglePage ? (
            <Text variant="header.Minor" color={textColor}>
              Back to ticket selection
            </Text>
          ) : (
            <Text variant="regular" color={textColor}>
              {backToLinkText}
            </Text>
          )}
        </HStack>
      </Link>
    )}
    <Text variant={"header.L"} color={textColor}>
      {title}
    </Text>
    {subTitle && (
      <Text color={textColor} variant="regular">
        {subTitle}
      </Text>
    )}
  </VStack>
);

export const DesktopSubHeader = ({
  isSinglePage,
  backToLinkText,
  backToLink = "/",
  hideBackLink = false,
  title,
  subTitle,
  colour = "white",
}: BaseSubHeaderProps) => (
  <Box
    width="100%"
    maxWidth="1248px"
    pl={4}
    mx={"auto" as any}
    mb={1}
    display={{ _: "none", md: "block" }}
  >
    {hideBackLink ? null : (
      <Link to={backToLink}>
        <Flex alignItems="center" opacity="inherit">
          <Icon icon="chevron-left" fontSize={5} color={colour} />
          {isSinglePage ? (
            <LegacyText
              as="h2"
              color={colour as any}
              fontWeight="extraBold"
              fontSize={3}
              lineHeight="medium"
              ml="3/4"
            >
              Back to ticket selection
            </LegacyText>
          ) : (
            <LegacyText
              color={colour}
              fontWeight="extraBold"
              fontSize={3}
              lineHeight="medium"
              ml="3/4"
            >
              {backToLinkText}
            </LegacyText>
          )}
        </Flex>
      </Link>
    )}
    <LegacyText
      as="h1"
      color={colour as any}
      fontWeight="heavy"
      fontSize={9}
      lineHeight={"56px" as any}
      mt={1}
    >
      {title}
    </LegacyText>
    {subTitle && (
      <LegacyText
        color={colour}
        fontWeight="heavy"
        fontSize={5}
        lineHeight={"95%" as any}
        mb={{ _: 0, md: 3 }}
      >
        {subTitle}
      </LegacyText>
    )}
  </Box>
);
